import BacktoHomeBtn from '@/components/commons/BacktoHomeBtn';
import {Divider, List, ListItem, ListItemIcon, ListItemText, makeStyles} from '@material-ui/core';
import React from 'react';
import { useTranslation } from "../../langs/useTranslation";
import StoreOutlinedIcon from '@material-ui/icons/StoreOutlined';
import SupervisorAccountOutlinedIcon from '@material-ui/icons/SupervisorAccountOutlined';
import {HomeOutlined} from '@material-ui/icons';
import {NavLink,useLocation} from 'react-router-dom';
import {Drawer} from '@material-ui/core'
import {useGlobalDispatch, useGlobalState} from '@/GlobalProvider';
const drawerWidth = 240;
const useStyles = makeStyles((theme) => ({
    drawerPaper: {
      width: drawerWidth,
      position: "fixed",
      top: theme.spacing(8),
      borderRight: "none",
      zIndex: "1",
      '&a': {
        color:"red !important"
      }
    },
    drawerPaper2: {
      width: '70px',
    },
    activeStyle: {
      '&.MuiList-root' :{
        backgroundColor: "red"
      }
    },
    ulCalss: {
      padding: '0',
      margin: '0'
    }
})
)

const MenuList = (props) => {
  const classes = useStyles();
  const { t } = useTranslation('common');
  const { pathname } = useLocation();
  const { menuFixedOpen } = useGlobalState();
  // const { setShowDetail } = useGlobalDispatch()

  const menuStyle = (path) => {
    if(path === pathname){
      return {
        backgroundColor: "#00afc6",
        color: "#ffffff"
      }
    }
    return {
      backgroundColor: "#ffffff",
      color: "rgba(0, 0, 0, 0.5)",
      borderBottom: "solid 1px rgba(0, 0, 0, 0.12)"
    }
  }
  const menuIconStyle = (path) => {
    if(path === pathname){
      return {
        backgroundColor: "#00afc6",
        color: "#ffffff"
      }
    }
    return {
      backgroundColor: "#ffffff",
      color: "rgba(0, 0, 0, 0.5)",
    }
  }


  const menuItemArr = [{
    path: '/',
    name: t('btn.backToHome'),
    iconComponent: HomeOutlined
  },{
    path: '/store-management',
    name: t({defaultMessage: '门店管理'}),
    iconComponent: StoreOutlinedIcon
  },{
    path: '/user-management',
    name: t({defaultMessage: '账号管理'}),
    iconComponent: SupervisorAccountOutlinedIcon
  }]

  // 路由守卫
  const routeGuard = () => {
    // setShowDetail(false)
  }

  return(
    <>
      <Drawer
        classes={{
          paper: !menuFixedOpen ? classes.drawerPaper : (classes.drawerPaper + ' ' + classes.drawerPaper2)
        }}
        variant="permanent"
        open
      >
        <div>
          {/*<div className={props.classes.toolbar} />*/}
          {
            menuItemArr.map((o, i) => {
              return (
                <NavLink to={o.path} key={i} onClick={()=>routeGuard()}>
                  <List className={`${classes.ulCalss} menu-ul`}>
                      <ListItem button style={menuStyle(o.path)}>
                        <ListItemIcon>
                          <o.iconComponent style={menuIconStyle(o.path)}/>
                        </ListItemIcon>
                        {!menuFixedOpen && <ListItemText>{o.name}</ListItemText>}
                      </ListItem>
                  </List>
                  {/*<Divider />*/}
                </NavLink>
              )
            })
          }
        </div>
      </Drawer>
    </>
  )
}

export default MenuList
